/**
 * @generated SignedSource<<5cc84bf27aa91dc595156e41883af339>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type reportedTimeComponent_Query$variables = {
  shareKey?: string | null;
  clientId?: string | null;
  personId?: string | null;
  projectId?: string | null;
  isProjectGroupType?: boolean | null;
  dateCriteria?: string | null;
  groupBy?: string | null;
  projectIds?: ReadonlyArray<string | null> | null;
  billableFilterValue?: boolean | null;
  personIds?: ReadonlyArray<string | null> | null;
  departmentIds?: ReadonlyArray<string | null> | null;
  teamIds?: ReadonlyArray<string | null> | null;
  roleIds?: ReadonlyArray<string | null> | null;
  labelIds?: ReadonlyArray<string | null> | null;
  skillIds?: ReadonlyArray<string | null> | null;
  componentId?: string | null;
};
export type reportedTimeComponent_Query$data = {
  readonly viewer: {
    readonly actualPersonId: string | null;
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"reportedTimeComponent_viewer">;
  } | null;
};
export type reportedTimeComponent_Query = {
  variables: reportedTimeComponent_Query$variables;
  response: reportedTimeComponent_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "billableFilterValue"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clientId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "componentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dateCriteria"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "departmentIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupBy"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectGroupType"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "labelIds"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "personIds"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectId"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIds"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "roleIds"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shareKey"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skillIds"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "insight_reported_time"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"insight_reported_time\")"
},
v18 = {
  "kind": "Variable",
  "name": "billableFilterValue",
  "variableName": "billableFilterValue"
},
v19 = {
  "kind": "Variable",
  "name": "clientId",
  "variableName": "clientId"
},
v20 = {
  "kind": "Variable",
  "name": "componentId",
  "variableName": "componentId"
},
v21 = {
  "kind": "Variable",
  "name": "dateCriteria",
  "variableName": "dateCriteria"
},
v22 = {
  "kind": "Variable",
  "name": "departmentIds",
  "variableName": "departmentIds"
},
v23 = {
  "kind": "Variable",
  "name": "groupBy",
  "variableName": "groupBy"
},
v24 = {
  "kind": "Variable",
  "name": "isProjectGroupType",
  "variableName": "isProjectGroupType"
},
v25 = {
  "kind": "Variable",
  "name": "labelIds",
  "variableName": "labelIds"
},
v26 = {
  "kind": "Variable",
  "name": "personId",
  "variableName": "personId"
},
v27 = {
  "kind": "Variable",
  "name": "personIds",
  "variableName": "personIds"
},
v28 = {
  "kind": "Variable",
  "name": "projectId",
  "variableName": "projectId"
},
v29 = {
  "kind": "Variable",
  "name": "projectIds",
  "variableName": "projectIds"
},
v30 = {
  "kind": "Variable",
  "name": "roleIds",
  "variableName": "roleIds"
},
v31 = {
  "kind": "Variable",
  "name": "shareKey",
  "variableName": "shareKey"
},
v32 = {
  "kind": "Variable",
  "name": "skillIds",
  "variableName": "skillIds"
},
v33 = {
  "kind": "Variable",
  "name": "teamIds",
  "variableName": "teamIds"
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "reportedTimeComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "args": [
              (v18/*: any*/),
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              (v26/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              (v29/*: any*/),
              (v30/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "reportedTimeComponent_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v13/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v11/*: any*/),
      (v0/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v15/*: any*/),
      (v12/*: any*/),
      (v7/*: any*/),
      (v14/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "reportedTimeComponent_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v16/*: any*/),
          (v17/*: any*/),
          {
            "alias": null,
            "args": [
              (v31/*: any*/)
            ],
            "concreteType": "InsightComponentsDataType",
            "kind": "LinkedField",
            "name": "insightComponentsData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/),
                  (v24/*: any*/),
                  (v25/*: any*/),
                  (v26/*: any*/),
                  (v27/*: any*/),
                  (v28/*: any*/),
                  (v29/*: any*/),
                  (v30/*: any*/),
                  (v32/*: any*/),
                  (v33/*: any*/)
                ],
                "concreteType": "ReportedTimeList",
                "kind": "LinkedField",
                "name": "reportedTimeList",
                "plural": false,
                "selections": [
                  (v34/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "currency",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReportedTimeListTimeRegType",
                    "kind": "LinkedField",
                    "name": "timeRegistrations",
                    "plural": true,
                    "selections": [
                      (v34/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "personName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "departmentName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "projectName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "roleNameOrNonProjTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "taskNameOrNonProjTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "groupingElementName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "minutesRegistered",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateYear",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateMonth",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "price",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cost",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "billable",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "notes",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clientName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v34/*: any*/)
            ],
            "storageKey": null
          },
          (v34/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "063402a42757e0b3ea8da44c23916692",
    "id": null,
    "metadata": {},
    "name": "reportedTimeComponent_Query",
    "operationKind": "query",
    "text": "query reportedTimeComponent_Query(\n  $shareKey: String\n  $clientId: ID\n  $personId: ID\n  $projectId: ID\n  $isProjectGroupType: Boolean\n  $dateCriteria: String\n  $groupBy: String\n  $projectIds: [ID]\n  $billableFilterValue: Boolean\n  $personIds: [ID]\n  $departmentIds: [ID]\n  $teamIds: [ID]\n  $roleIds: [ID]\n  $labelIds: [ID]\n  $skillIds: [ID]\n  $componentId: ID\n) {\n  viewer {\n    actualPersonId\n    component(name: \"insight_reported_time\")\n    ...reportedTimeComponent_viewer_1UO2N4\n    id\n  }\n}\n\nfragment reportedTimeComponent_viewer_1UO2N4 on Viewer {\n  insightComponentsData(shareKey: $shareKey) {\n    reportedTimeList(projectId: $projectId, isProjectGroupType: $isProjectGroupType, clientId: $clientId, personId: $personId, dateCriteria: $dateCriteria, groupBy: $groupBy, projectIds: $projectIds, billableFilterValue: $billableFilterValue, personIds: $personIds, departmentIds: $departmentIds, teamIds: $teamIds, roleIds: $roleIds, labelIds: $labelIds, skillIds: $skillIds, componentId: $componentId) {\n      id\n      currency\n      timeRegistrations {\n        id\n        personName\n        departmentName\n        projectName\n        roleNameOrNonProjTime\n        taskNameOrNonProjTime\n        groupingElementName\n        minutesRegistered\n        dateYear\n        dateMonth\n        dateDay\n        price\n        cost\n        billable\n        notes\n        clientName\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b5592ff850653b0beb7cc8ee6c08019c";

export default node;
